// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5375":"css/admin-app.6828","5766":"css/app.6828"}[chunkId] + ".css";
};